import { render, staticRenderFns } from "./SectionTotalTags.vue?vue&type=template&id=5c6ec1f3&scoped=true&"
import script from "./SectionTotalTags.vue?vue&type=script&lang=js&"
export * from "./SectionTotalTags.vue?vue&type=script&lang=js&"
import style0 from "./SectionTotalTags.vue?vue&type=style&index=0&id=5c6ec1f3&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6ec1f3",
  null
  
)

export default component.exports